export default __webpack_public_path__ + "static/media/celebrate.acb5eb3524ad92d4aea3dd065ae24082.svg";